import { Controller } from '@hotwired/stimulus'
import { smoothScrollTo } from '../utilities.js'

export default class extends Controller {
  static targets = ['tablist', 'tab', 'tabpanel']
  static values = { autoAlign: { type: Boolean, default: false } }

  connect() {
    this.boundJustifyTabs = this.#justifyTabs.bind(this)

    if (this.autoAlignValue) {
      window.addEventListener('resize', this.boundJustifyTabs)
      this.boundJustifyTabs()
    }

    const { hash } = window.location
    if (hash) this.activateTab(false, hash.replace('#', ''))
  }

  disconnect() {
    window.removeEventListener('resize', this.boundJustifyTabs)
  }

  activateTab(event, id = null, options = {}) {
    const defaultOptions = { updateURL: true, scroll: true }
    options = { ...defaultOptions, ...options }

    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tabId === id
      tab.dataset.active = active
      if (active && (event || options.scroll)) this.#scrollTabIntoView(tab)
    })

    this.tabpanelTargets.forEach(tabpanel => {
      const active = tabpanel.dataset.tabId === id
      tabpanel.dataset.active = active
      tabpanel.dataset.ariaExpanded = active
    })

    if (!options.updateURL) return

    // append tab ID hash to URL and add it to the browser's history
    const newURL = new URL(window.location)
    newURL.hash = id
    window.history.pushState(null, '', newURL)
  }

  toggleTab(event) {
    this.activateTab(event, event.currentTarget.dataset.tabId)
  }

  #justifyTabs() {
    this.tablistTargets.forEach(tablist => {
      if (tablist.dataset.autoAlign === false) return

      if (tablist.scrollWidth > tablist.clientWidth) {
        tablist.classList.add('justify-start')
        tablist.classList.remove('justify-center')
      } else {
        tablist.classList.add('justify-center')
        tablist.classList.remove('justify-start')
      }
    })
  }

  #scrollTabIntoView(tab) {
    const container = tab.closest('[role="tablist"]')
    const containerRect = container.getBoundingClientRect()
    const targetRect = tab.getBoundingClientRect()

    const offset = targetRect.left - containerRect.left
    const scrollOffset =
      offset - (container.clientWidth / 2 - tab.clientWidth / 2)
    let targetScrollLeft = container.scrollLeft + scrollOffset

    // Clamp to scrollable bounds
    const maxScroll = container.scrollWidth - container.clientWidth
    targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScroll))

    smoothScrollTo(targetScrollLeft, container, 'x')
  }

}
